module.exports = __webpack_public_path__ + "static/media/Woodside_Village_Bylaws_and_Master_Deed.e9cf2044.pdf";